var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn add-valve",on:{"click":_vm.onClick}},[_c('span',[_vm._v(_vm._s(_vm.pName))]),(_vm.icon)?_c('span',[_vm._v("+")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }